import { useCallback } from "react";
import { AlertColor } from "@mui/material/Alert";
import { Toast } from "@shopify/polaris";

interface Props {
	notice: { type: AlertColor; message: string };
	showNotice: boolean;
	setShowNotice: React.Dispatch<React.SetStateAction<boolean>>;
}

const SettingsSnackbar = ({ notice, showNotice, setShowNotice }: Props) => {
	const toggleActive = useCallback(() => setShowNotice((show) => !show), []);

	const toast = showNotice ? (
		<Toast
			content={notice.message}
			onDismiss={toggleActive}
			error={notice.type === "error"}
		/>
	) : null;

	return toast;
};

export default SettingsSnackbar;
